import { Dispatch, useEffect, useState } from "react";
import PassengerList from "./PassengerList";
import TripType from "./TripType";
import { IoIosAirplane } from "react-icons/io";

import { BiSearchAlt } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import "../../Components/DatePicker/index.css";
import { errorMessage } from "../../util/Helpers";
import * as Actions from "../../store/actions";
import { useNavigate } from "react-router-dom";
import { formatPassengerToTravelers } from "../../util/FilterOffer";
import { encodeObject } from "../../util/QueryUtils";
import BasicAirportSearchInput from "../../Components/Inputs/BasicAirportSearchInput";

import BasicSelectPlain from "../../Components/Inputs/BasicSelectPlain";
import AdvancedSearch from "./AdvancedSearch";
import { getFingerprint } from "../../util/Helpers2";
import RangePicker from "../../util/RangePicker";
import DatePicker from "../../util/DatePicker";
import { Mixpanel } from "../../mixPanelHooks";

const FlightGroup = ({ setVisibleItems, queryPayload, dark = false }: any) => {
  const dispatch: Dispatch<any> = useDispatch();

  const navigate = useNavigate();
  const tripType = ["One-way", "Round-trip"];
  const tripType1 = useSelector((state: any) => state.form.tripType);
  const flightType1 = useSelector((state: any) => state.form.flightType);
  const airport = useSelector((state: any) => state.form.airport);
  const passenger = useSelector((state: any) => state.form.passenger);
  const currency = useSelector((state: any) => state.app.currency);
  const date = useSelector((state: any) => state.form.date);
  const loading = useSelector((state: any) => state.flight.loading);
  const nearbyairport = useSelector((state: any) => state.form.nearbyairport);
  const refundable = useSelector((state: any) => state.form.refundable);
  const info = useSelector((state: any) => state.app.info);
  const user = useSelector((state: any) => state.client.user);
  const includedCarrier = useSelector(
    (state: any) => state.form.includedCarrier
  );

  const [open, setOpen] = useState(false);

  const [switchLocale, setSwitchLocale] = useState(false);

  const flightType = ["Economy", "Premium", "Business", "First"];

  useEffect(() => {
    if (includedCarrier.length > 0) {
      setOpen(true);
    }
  }, [includedCarrier]);

  const getInckudedCarrier = () => {
    let x: any = [];
    for (const item of includedCarrier) {
      x = [...x, item.code];
    }

    return x;
  };

  const getSubmittedData = async () => {
    let deviceid = await getFingerprint();
    let error = false;
    if (!flightType1) {
      errorMessage("Please select a cabin");
      error = true;
    } else if (!tripType1) {
      errorMessage("Please select a trip type");
      error = true;
    } else if (!airport.leaving) {
      errorMessage("Please select a departure");
      error = true;
    } else if (!airport.going) {
      errorMessage("Please select an arrival");
      error = true;
    } else if (!date.startDate) {
      errorMessage("Please select a departure date");
      error = true;
    } else if (!date.endDate && tripType1 === "Round-trip") {
      errorMessage("Please select a return date");
      error = true;
    }

    if (!error) {
      let originDestinations: any = [
        {
          originlocation: airport.leaving.code,
          destinationlocation: airport.going.code,
          departuredate: date.startDate,
        },
      ];
      if (tripType1 === "Round-trip") {
        originDestinations = [
          ...originDestinations,
          {
            originlocation: airport.going.code,
            destinationlocation: airport.leaving.code,
            departuredate: date.endDate,
          },
        ];
      }
      let submittedData: any = {
        currency: currency.code,
        origindestinations: originDestinations,
        triptype: tripType1 === "Round-trip" ? "return" : "oneway",
        travelers: formatPassengerToTravelers(passenger),

        criteria: {
          maxresult: 200,
          preference: flightType1.toLowerCase(),
          excludedcarrier: [],
          includedcarrier: getInckudedCarrier(),
        },
        nearbyairport,
        refundable,
        deviceid,
        locale: info?.city_name,
        email: user?.email,
      };

      return submittedData;
    } else {
      return error;
    }
  };

  const searchDeals = async () => {
    const submittedData = await getSubmittedData();
    if (submittedData.currency) {
      let x = encodeObject(submittedData);
      if (location.pathname.includes(`/flights/results/`)) {
        dispatch(Actions.resetFlight());
        setVisibleItems(20);
        console.log("sdsfsf");
        Mixpanel.track("Flight Search", {
          departure: airport.leaving.code,
          arrival: airport.going.code,
          date: date.startDate,
        });
        dispatch(
          Actions.searchFlightOffersPriority(
            submittedData,
            () => {
              navigate(
                `/flights/results/${airport.leaving.code}-${airport.going.code}?ref=${x}`
              );
            },
            () => {}
          )
        );
      } else {
        navigate(
          `/flights/results/${airport.leaving.code}-${airport.going.code}?ref=${x}`
        );
      }
    }
  };

  return (
    <div className="w-full ">
      <div className="flex w-full justify-between items-start">
        <div className="md:hidden flex space-x-5">
          {" "}
          <div className="flex items-center mb-2">
            <div
              className={`w-5 h-5 p-[2px] mr-1 border-[1px] cursor-pointer rounded-full flex items-center justify-center ${dark ? "border-white/35" : "border-neutral-400"}`}
              onClick={() => {
                dispatch(Actions.selectTripType("One-way"));
              }}
            >
              {" "}
              {tripType1 === "One-way" && (
                <div className={`w-full h-full rounded-full ${dark ? "bg-orange-500" : "bg-[#000046]"}`} />
              )}
            </div>
            <div className={`font-medium text-xs ${dark ? "text-white" : "text-[#000046]"}`}>One way</div>
          </div>
          <div className="flex items-center mb-2">
            <div
              className={`w-5 h-5 p-[2px] mr-1 border-[1px] cursor-pointer rounded-full flex items-center justify-center ${dark ? "border-white/35" : "border-neutral-400"}`}
              onClick={() => {
                dispatch(Actions.selectTripType("Round-trip"));
              }}
            >
              {" "}
              {tripType1 === "Round-trip" && (
                <div className={`w-full h-full rounded-full ${dark ? "bg-orange-500" : "bg-[#000046]"}`} />
              )}
            </div>
            <div className={`font-medium text-xs ${dark ? "text-white" : "text-[#000046]"}`}>Round trip</div>
          </div>
        </div>
        <div className="md:block hidden">
          <TripType options={tripType} name="tripType" dark={dark} />
          <PassengerList dark={dark} />
          <TripType options={flightType} name="flightType" dark={dark} />
        </div>
        <div>
          <div className="flex items-center mb-2">
            <div
              className={`w-5 h-5 p-[2px] mr-1 border-[1px] cursor-pointer rounded-sm flex items-center justify-center ${dark ? "border-white/35" : "border-neutral-400"}`}
              onClick={() => {
                dispatch(Actions.nearByAirprtToggle());
              }}
            >
              {" "}
              {nearbyairport && (
                <div className={`w-full h-full rounded-sm ${dark ? "bg-orange-500" : "bg-[#000046]"}`} />
              )}
            </div>
            <div className={`font-medium text-xs md:text-sm ${dark ? "text-white/75" : "text-slate-700"}`}>
              Include nearby airport
            </div>
          </div>
          <div className="flex items-center mb-2">
            <div
              className={`w-5 h-5 p-[2px] mr-1 border-[1px] cursor-pointer rounded-sm flex items-center justify-center ${dark ? "border-white/35" : "border-neutral-400"}`}
              onClick={() => {
                dispatch(Actions.setRefundable());
              }}
            >
              {" "}
              {refundable && (
                <div className={`w-full h-full rounded-sm ${dark ? "bg-orange-500" : "bg-[#000046]"}`} />
              )}
            </div>
            <div className={`font-medium text-xs md:text-sm ${dark ? "text-white/75" : "text-slate-700"}`}>
              Only refundable
            </div>
          </div>
        </div>
      </div>
      <div className="w-full block xl:flex items-center mt-2 gap-2">
        <div className="w-full xl:w-[52%] flex relative gap-2">
          <div className="relative w-1/2">
            <BasicAirportSearchInput
              name="From"
              variant={dark ? "dark" : "light"}
              initialSearch={
                queryPayload?.origindestinations[0]?.originlocation
              }
              placeholder="Leaving from"
              value={airport["leaving"]}
              onChange={(e: any) => {
                if (airport["going"]) {
                  if (e.code !== airport["going"].code) {
                    dispatch(Actions.selectAirport("leaving", e));
                  } else {
                    dispatch(Actions.selectAirport("leaving", null));
                    errorMessage(
                      "Can't add similar route as destination/arrival"
                    );
                  }
                } else {
                  dispatch(Actions.selectAirport("leaving", e));
                }
              }}
            />
          </div>
          <div
            onClick={() => {
              dispatch(Actions.selectAirport("leaving", airport.going));
              dispatch(Actions.selectAirport("going", airport.leaving));
              setSwitchLocale(true);
              setTimeout(() => {
                setSwitchLocale(false);
              }, 1000);
            }}
            className={
              dark
                ? "absolute min cursor-pointer  z-[1]  -w-28 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  rounded-full bg-orange-500 shadow-[0_8px_24px_-6px_rgba(255,106,26,.75)]"
                : "absolute min cursor-pointer  z-[1]  -w-28 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  border-4 border-white rounded-full bg-white"
            }
          >
            <div
              className={`${switchLocale && "rotate-180 "} `}
              style={
                dark
                  ? { padding: "8px" }
                  : {
                      backgroundImage: "url(/rotate.png)",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      padding: "4px",
                    }
              }
            >
              <IoIosAirplane className={dark ? "text-xl text-white" : "text-xl text-orange-500"} />
            </div>
          </div>
          <div className="relative w-1/2">
            <BasicAirportSearchInput
              name="To"
              variant={dark ? "dark" : "light"}
              placeholder="Going to"
              initialSearch={
                queryPayload?.origindestinations[0]?.destinationlocation
              }
              value={airport["going"]}
              onChange={(e: any) => {
                if (airport["leaving"]) {
                  if (e.code !== airport["leaving"].code) {
                    dispatch(Actions.selectAirport("going", e));
                  } else {
                    dispatch(Actions.selectAirport("going", null));
                    errorMessage(
                      "Can't add similar route as destination/arrival"
                    );
                  }
                } else {
                  dispatch(Actions.selectAirport("going", e));
                }
              }}
            />
          </div>
        </div>
        <div className="md:hidden block w-full mt-3">
          <BasicSelectPlain
            label="Select Cabin"
            dark={dark}
            value={flightType1}
            name="Select Cabin"
            getOptionLabel={(option: any) => option.name}
            getOptionValue={(option: any) => option.name}
            onChange={(e: any) => dispatch(Actions.selectFlightType(e))}
            data={[
              { name: "Economy" },
              { name: "Premium" },
              { name: "Business" },
              { name: "First" },
            ]}
          />
        </div>

        <div className="w-full mt-4 xl:mt-0 xl:w-[48%] md:flex items-center gap-2 z-[1]">
          <div className="flex-1">
            {tripType1 !== "One-way" ? <RangePicker dark={dark} /> : <DatePicker dark={dark} />}
          </div>
          <button
            type="button"
            onClick={searchDeals}
            disabled={loading}
            className="bg-orange-500 w-1/3  h-14 m-[2px] justify-center text-lg items-center gap-2 flex text-white px-4 rounded disabled:bg-orange-200 hover:bg-orange-400  focus:outline-none focus:bg-orange-400"
          >
            <BiSearchAlt />
            {location.pathname.includes(`/flights/results/`)
              ? "Modify"
              : "Search"}
          </button>
        </div>
      </div>

      <div className="w-full">
        <AdvancedSearch open={open} setOpen={setOpen} dark={dark}></AdvancedSearch>
      </div>
    </div>
  );
};
export default FlightGroup;
